<template>
  <div id="printBodyRV">
    <table class="table table-sm table-bordered">
      <tbody>
      <tr>
        <td>Организация: {{org.name}}, ИИН/БИН: {{ org.iinbin }}</td>
      </tr>
      </tbody>
    </table>

    <h4 class="text-center">Расчетная ведомость за {{ getMonthName(month) + ' ' + year }} г.</h4>

    <table class="table table-sm table-bordered table-striped table-12">
      <tbody>
      <template v-if="fields.taxable == 1">
      <tr class="bg-primary text-white">
        <th rowspan="2">№</th>
        <th rowspan="2" v-if="fields.month == 1">Месяц</th>
        <th rowspan="2" v-if="fields.workername == 1">Ф.И.О.</th>
        <th rowspan="2" v-if="fields.workerfunction == 1">Должность</th>
        <th rowspan="2" v-if="fields.iin == 1">ИИН</th>
        <th rowspan="2" v-if="fields.dh == 1">Дни/Часы</th>
        <th rowspan="2" v-if="fields.sum == 1">Начисления</th>
        <th rowspan="2" v-if="fields.deduction == 1">Удержания</th>
        <th rowspan="2" v-if="fields.worker == 1">На руки</th>
        <th rowspan="2" v-if="fields.recoupment == 1">Вычеты</th>
        <th rowspan="2" v-if="fields.adjustment == 1">Корректировка 90%</th>
        <th colspan="2" v-if="fields.opv == 1">ОПВ</th>
        <th colspan="2" v-if="fields.opvr == 1">ОПВР</th>
        <th colspan="2" v-if="fields.oppv == 1">ОППВ</th>
        <th colspan="2" v-if="fields.ipn == 1">ИПН</th>
        <th colspan="2" v-if="fields.sn == 1">СН</th>
        <th colspan="2" v-if="fields.so == 1">СО</th>
        <th colspan="2" v-if="fields.oosms == 1">ООСМС</th>
        <th colspan="2" v-if="fields.vosms == 1">ВОСМС</th>
      </tr>
        <tr class="bg-primary text-white">
          <th v-if="fields.opv == 1">Обл.доход</th>
          <th v-if="fields.opv == 1">Знач.</th>
          <th v-if="fields.opvr == 1">Обл.доход</th>
          <th v-if="fields.opvr == 1">Знач.</th>
          <th v-if="fields.oppv == 1">Обл.доход</th>
          <th v-if="fields.oppv == 1">Знач.</th>
          <th v-if="fields.ipn == 1">Обл.доход</th>
          <th v-if="fields.ipn == 1">Знач.</th>
          <th v-if="fields.sn == 1">Обл.доход</th>
          <th v-if="fields.sn == 1">Знач.</th>
          <th v-if="fields.so == 1">Обл.доход</th>
          <th v-if="fields.so == 1">Знач.</th>
          <th v-if="fields.oosms == 1">Обл.доход</th>
          <th v-if="fields.oosms == 1">Знач.</th>
          <th v-if="fields.vosms == 1">Обл.доход</th>
          <th v-if="fields.vosms == 1">Знач.</th>

        </tr>
      </template>

      <template v-else>
      <tr class="bg-primary text-white">
        <th>№</th>
        <th v-if="fields.month == 1">Месяц</th>
        <th v-if="fields.workername == 1">Ф.И.О.</th>
        <th v-if="fields.workerfunction == 1">Должность</th>
        <th v-if="fields.iin == 1">ИИН</th>
        <th v-if="fields.dh == 1">Дни/Часы</th>
        <th v-if="fields.sum == 1">Начисления</th>
        <th v-if="fields.deduction == 1">Удержания</th>
        <th v-if="fields.worker == 1">На руки</th>
        <th v-if="fields.recoupment == 1">Вычеты</th>
        <th v-if="fields.adjustment == 1">Корректировка 90%</th>
        <th v-if="fields.opv == 1">ОПВ</th>
        <th v-if="fields.opvr == 1">ОПВР</th>
        <th v-if="fields.oppv == 1">ОППВ</th>
        <th v-if="fields.ipn == 1">ИПН</th>
        <th v-if="fields.sn == 1">СН</th>
        <th v-if="fields.so == 1">СО</th>
        <th v-if="fields.oosms == 1">ООСМС</th>
        <th v-if="fields.vosms == 1">ВОСМС</th>
      </tr>
      </template>

      <template v-for="(item, index) in list">
        <tr :key="item.id">
          <td>{{index + 1}}</td>
          <td v-if="fields.month == 1">{{ getMonthName(item.month )}}</td>
          <td v-if="fields.workername == 1">
            {{ item.last_name + ' ' + item.first_name + ' ' + item.middle_name }}
          </td>
          <td v-if="fields.workerfunction == 1">{{ item.workerfunction }}</td>
          <td v-if="fields.iin == 1">{{ item.iin }}</td>
          <!--<td v-if="fields.dh == 1">{{ item.days + '/' + item.hours }}</td>-->
          <td v-if="fields.dh == 1">{{ getPeriod(item) }}</td>
          <td v-if="fields.sum == 1">{{ item.res_sum }}</td>
          <td v-if="fields.deduction == 1">{{ item.res_deduction }}</td>
          <td v-if="fields.worker == 1">{{ item.res_worker }}</td>
          <td v-if="fields.recoupment == 1">{{ item.recoupmentipn }}</td>
          <td v-if="fields.adjustment == 1">{{ item.res_adjustment }}</td>

          <td v-if="fields.opv == 1 && fields.taxable == 1">{{ item.res_opvtaxable }}</td>
          <td v-if="fields.opv == 1">{{ item.res_opv }}</td>

          <td v-if="fields.opvr == 1 && fields.taxable == 1">{{ item.res_opvrtaxable }}</td>
          <td v-if="fields.opvr == 1">{{ item.res_opvr }}</td>

          <td v-if="fields.oppv == 1 && fields.taxable == 1">{{ item.res_oppvtaxable }}</td>
          <td v-if="fields.oppv == 1">{{ item.res_oppv }}</td>

          <td v-if="fields.ipn == 1 && fields.taxable == 1">{{ item.res_ipntaxable }}</td>
          <td v-if="fields.ipn == 1">{{ item.res_ipn }}</td>

          <td v-if="fields.sn == 1 && fields.taxable == 1">{{ item.res_sntaxable }}</td>
          <td v-if="fields.sn == 1">{{ item.res_sn }}</td>

          <td v-if="fields.so == 1 && fields.taxable == 1">{{ item.res_sotaxable }}</td>
          <td v-if="fields.so == 1">{{ item.res_so }}</td>

          <td v-if="fields.oosms == 1 && fields.taxable == 1">{{ item.res_oosmstaxable }}</td>
          <td v-if="fields.oosms == 1">{{ item.res_oosms }}</td>

          <td v-if="fields.vosms == 1 && fields.taxable == 1">{{ item.res_vosmstaxable }}</td>
          <td v-if="fields.vosms == 1">{{ item.res_vosms }}</td>
        </tr>

      </template>
      <tr v-if="fields.amount == 1">
        <td></td>
        <td v-if="fields.workername == 1"><strong>ИТОГО</strong></td>
        <td v-if="fields.month == 1"><strong></strong></td>
        <td v-if="fields.workerfunction == 1"><strong></strong></td>
        <td v-if="fields.iin == 1"><strong></strong></td>
        <td v-if="fields.dh == 1"><strong></strong></td>
        <td v-if="fields.sum == 1"><strong>{{ getAmountField(list, 'res_sum') }}</strong>
        </td>
        <td v-if="fields.deduction == 1">
          <strong>{{ getAmountField(list, 'res_deduction') }}</strong></td>
        <td v-if="fields.worker == 1">
          <strong>{{ getAmountField(list, 'res_worker') }}</strong></td>
        <td v-if="fields.recoupment == 1">
          <strong>{{ getAmountField(list, 'recoupmentipn') }}</strong></td>
        <td v-if="fields.adjustment == 1">
          <strong>{{ getAmountField(list, 'res_adjustment') }}</strong></td>

        <td v-if="fields.opv == 1 && fields.taxable == 1"><strong>{{ getAmountField(list, 'res_opvtaxable') }}</strong></td>
        <td v-if="fields.opv == 1"><strong>{{ getAmountField(list, 'res_opv') }}</strong>
        </td>

        <td v-if="fields.opvr == 1 && fields.taxable == 1"><strong>{{ getAmountField(list, 'res_opvrtaxable') }}</strong></td>
        <td v-if="fields.opvr == 1"><strong>{{ getAmountField(list, 'res_opvr') }}</strong>
        </td>

        <td v-if="fields.oppv == 1 && fields.taxable == 1"><strong>{{ getAmountField(list, 'res_oppvtaxable') }}</strong></td>
        <td v-if="fields.oppv == 1"><strong>{{ getAmountField(list, 'res_oppv') }}</strong>
        </td>

        <td v-if="fields.ipn == 1 && fields.taxable == 1"><strong>{{ getAmountField(list, 'res_ipntaxable') }}</strong></td>
        <td v-if="fields.ipn == 1"><strong>{{ getAmountField(list, 'res_ipn') }}</strong>
        </td>

        <td v-if="fields.sn == 1 && fields.taxable == 1"><strong>{{ getAmountField(list, 'res_sntaxable') }}</strong></td>
        <td v-if="fields.sn == 1"><strong>{{ getAmountField(list, 'res_sn') }}</strong></td>

        <td v-if="fields.so == 1 && fields.taxable == 1"><strong>{{ getAmountField(list, 'res_sotaxable') }}</strong></td>
        <td v-if="fields.so == 1"><strong>{{ getAmountField(list, 'res_so') }}</strong></td>

        <td v-if="fields.oosms == 1 && fields.taxable == 1"><strong>{{ getAmountField(list, 'res_oosmstaxable') }}</strong></td>
        <td v-if="fields.oosms == 1">
          <strong>{{ getAmountField(list, 'res_oosms') }}</strong></td>

        <td v-if="fields.vosms == 1 && fields.taxable == 1"><strong>{{ getAmountField(list, 'res_vosmstaxable') }}</strong></td>
        <td v-if="fields.vosms == 1">
          <strong>{{ getAmountField(list, 'res_vosms') }}</strong></td>
      </tr>
      </tbody>
    </table>

    <Signature :org="org"></Signature>
  </div>
</template>


<script>
import Signature from "@/components/print/parts/Signature";
export default {
  components: {
    Signature
  },
  props: ['list', 'fields', 'year', 'month', 'org'],
  methods: {

    getPeriod: function (item) {
      let period = '';
      if (item.sum_period == 0 && item.sum1_period == 0 && item.sum2_period == 0 && item.sum3_period == 0) {
        // По старому
        period = item.days + '/' + item.hours;
      }
      if (item.sum_mode == 'days') {
        period = item.sum_period + ' дн.';
      }
      if (item.sum_mode == 'hours') {
        period = item.sum_period + ' ч.';
      }
      return period;
    }
  }
}
</script>


<style>

</style>
